import LogoImage from '@src/images/components/footer/logo.png';

import * as S from './styles';

const DesktopFooter = (props: any) => (
  <S.DesktopFooterContainer {...props}>
    <S.FooterTopWrapper>
      <S.Text to={{ pathname: '/privacy' }}>개인정보처리방침</S.Text>
      <S.Text to={{ pathname: '/terms' }}>서비스 이용약관</S.Text>
    </S.FooterTopWrapper>
    <S.FooterBottomWrapper>
      <S.Logo src={LogoImage} />
      <S.TextContainer>
        <div>
          <S.BottomBoldText>문의처&nbsp;&nbsp;cccv@cccv.to</S.BottomBoldText>
          {/* <BottomSeparator />
            <BottomBoldText>031-8022-6264</BottomBoldText> */}
        </div>
        <S.CopyrightText>
          COPYRIGHT(c)Province of KEYPLAY. ALL RIGHT RESERVED.
        </S.CopyrightText>
      </S.TextContainer>
    </S.FooterBottomWrapper>
  </S.DesktopFooterContainer>
);

export default DesktopFooter;
